export function useFormatter() {
  const currency = (value: number): string => {
    if (isNaN(value)) return "-";
    const formatter = new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
    });
    return formatter.format(value);
  };

  return { currency };
}
